import { setToken, setUsuario } from "./auth";

/**
 * Painel embutido no ERP (iframe): o ERP abre "#<tela>&embed=1&t=<jwt>". Guarda o acesso do usuário,
 * marca o modo embutido e limpa o token do endereço. Chamado antes de montar o App.
 */
export function aplicarSsoDoHash(): void {
  const h = window.location.hash.replace(/^#/, "");
  if (!h.includes("&")) return;
  const [rota, ...params] = h.split("&");
  const p = new URLSearchParams(params.join("&"));
  const t = p.get("t");
  if (t) {
    try {
      const corpo = JSON.parse(atob(t.split(".")[1]!.replace(/-/g, "+").replace(/_/g, "/")));
      setToken(t);
      setUsuario({ codusu: Number(corpo.sub), apelid: String(corpo.apelid ?? ""), nomusu: String(corpo.nomusu ?? "") });
    } catch {
      /* token inválido: segue para o login */
    }
  }
  if (p.get("embed") === "1") sessionStorage.setItem("formsteel-embed", "1");
  window.history.replaceState(null, "", window.location.pathname + (rota ? "#" + rota : ""));
}

export const ehEmbutido = () => sessionStorage.getItem("formsteel-embed") === "1";
